import { Injectable, Injector } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment } from '@environments/environment';
import { UserDTO } from '@app/shared/interfaces/user';
import { mixpanelEventTypes } from '@app/shared/enums/mixpanel.enum';
import { EnvironmentNameEnum } from '@environments/environment.enum';
import { UserService } from '@app/admin-station/work-center/user/services/user.service';
@Injectable({
  providedIn: 'root',
})
export class MixpanelService {
  // use injector to add dependencies to avoid circular dependency error,
  // since most services will have a dependency on this service in order to track events.
  constructor(private injector: Injector) {
    const mixpanelToken = environment.mixPanel.mixpanelToken;
    if (mixpanelToken) {
      mixpanel.init(mixpanelToken);
    }
  }

  public trackEvent(eventType: mixpanelEventTypes, eventParams?: IMixpanelEventParams): void {
    if (environment.name !== EnvironmentNameEnum.PROD) {
      return;
    }

    const userService = this.injector.get(UserService);
    userService.userLoginData$.subscribe((userData: UserDTO) => {
      if (!userData) return;

      mixpanel.track(eventType, {
        distinct_id: userData.email,
        fullName: userData.fullName,
        orgId: userData.orgId,
        userId: userData.userId,
        ...eventParams,
      });
    })
  }
}

export interface IMixpanelEventParams {
  [key: string]: string | number;
}
